export default __webpack_public_path__ + "static/media/DownloadExcel.10a09e6f.svg";